import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { UiState } from '../state';

enum ActionTypes {
  ShowOrganizationInfo = 'header/showOrganizationInfo',
  HideOrganizationInfo = 'header/hideOrganizationInfo',
}

export interface HeaderAction {
  type: ActionTypes;
}

export const showOrganizationInfo = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => (dispatch, getState) => {
  if (!getState().ui.headerState.visibleOrganizationInfo) {
    dispatch({
      type: ActionTypes.ShowOrganizationInfo,
    });
  }
};

export const hideOrganizationInfo = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => (dispatch, getState) => {
  if (getState().ui.headerState.visibleOrganizationInfo) {
    dispatch({
      type: ActionTypes.HideOrganizationInfo,
    });
  }
};

export const HeaderActionDelegate: DelegateMapEntry<HeaderAction, UiState> = {
  [ActionTypes.ShowOrganizationInfo]: (
    state: UiState,
    action: HeaderAction
  ): UiState => {
    return {
      ...state,
      headerState: {
        ...state.headerState,
        visibleOrganizationInfo: true,
      },
    };
  },
  [ActionTypes.HideOrganizationInfo]: (
    state: UiState,
    action: HeaderAction
  ): UiState => {
    return {
      ...state,
      headerState: {
        ...state.headerState,
        visibleOrganizationInfo: false,
      },
    };
  },
};
